<span matSnackBarLabel class="flex justify-center text-[#000]">
  {{ data.err }}
</span>
